import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import ThemeGrid from "../components/tables/ThemeGrid";

export default function ThemePage() {
    return (
        <>
            <PageMeta
                title="Theme Management | Shoplattice Admin Dashboard"
                description="Manage Themes and Appearance"
            />
            <PageBreadcrumb pageTitle="Theme Management" />
            <div className="space-y-6">
                <ThemeGrid />
            </div>
        </>
    );
}
